/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsViewsVwPafAddress,
  VwPAFAddressParams
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves all addresses for a given UK postcode using the consolidated PAF view. This provides a simplified alternative to the individual PAF area controllers, offering unified search across all UK addresses with consistent formatting and structure. The search is case-insensitive and handles postcodes with or without spaces, returning complete address details suitable for customer selection and booking forms.
 * @summary Get addresses from postcode
 */
export const vwPAFAddress = (
    params: VwPAFAddressParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsViewsVwPafAddress[]>(
      {url: `/api/VwPAFAddress/Postcode`, method: 'POST',
        params
    },
      options);
    }
  export type VwPAFAddressResult = NonNullable<Awaited<ReturnType<typeof vwPAFAddress>>>
